import { useEffect, useState } from 'react';
import { galleryData } from '@/mocks/homeData';

const categories = ['Todos', 'Flota', 'Interior', 'Cobertura'];

export default function GallerySection() {
  const [activeCategory, setActiveCategory] = useState('Todos');

  const filtered = activeCategory === 'Todos'
    ? galleryData
    : galleryData.filter((item) => item.category === activeCategory);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = document.querySelectorAll('.gallery-animate');
    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [activeCategory]);

  return (
    <section id="galeria" className="py-20 md:py-32 bg-yakis-cream relative">
      <div className="section-container">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14">
          <div className="gallery-animate animate-on-scroll mb-4">
            <span className="text-yakis-gold text-sm font-semibold tracking-wider uppercase">
              Nuestra Flota
            </span>
          </div>
          <h2 className="gallery-animate animate-on-scroll font-display font-bold text-3xl sm:text-4xl md:text-5xl text-yakis-navy leading-tight mb-4">
            Conoce la flota que
            <br />
            <span className="text-yakis-gold">impulsa tu empresa</span>
          </h2>
          <p className="gallery-animate animate-on-scroll text-yakis-silver text-base md:text-lg">
            Autobuses y unidades ejecutivas equipadas con la última tecnología 
            de seguridad y confort para tu personal.
          </p>
        </div>

        {/* Filter Tabs */}
        <div className="gallery-animate animate-on-scroll flex flex-wrap justify-center gap-2 mb-8 md:mb-12">
          {categories.map((cat) => (
            <button
              key={cat}
              type="button"
              onClick={() => setActiveCategory(cat)}
              className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
                activeCategory === cat
                  ? 'bg-yakis-navy text-white shadow-md'
                  : 'bg-white text-yakis-silver hover:bg-yakis-navy/5'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {filtered.map((item, index) => (
            <div
              key={item.id}
              className="gallery-animate animate-on-scroll group relative rounded-2xl overflow-hidden bg-white shadow-sm transition-all duration-500 hover:shadow-xl"
              style={{ transitionDelay: `${index * 60}ms` }}
            >
              <div className={`relative overflow-hidden ${
                index === 0 || index === 5 ? 'aspect-[16/10]' : 'aspect-[4/3]'
              }`}>
                <img
                  src={item.src}
                  alt={item.alt}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                />
                {/* Overlay on hover */}
                <div className="absolute inset-0 bg-yakis-navy/0 group-hover:bg-yakis-navy/40 transition-all duration-500 flex items-end">
                  <div className="p-5 translate-y-full group-hover:translate-y-0 transition-transform duration-500">
                    <span className="inline-flex items-center gap-1 px-3 py-1 bg-yakis-gold/90 rounded-full text-xs font-medium text-yakis-navy">
                      {item.category}
                    </span>
                    <p className="text-white text-sm mt-2 font-medium">
                      {item.alt}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}